import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILoginUser } from "../@types/auth";

type IUserProfileState = {
  profile: ILoginUser | null;
  loading: boolean;
  error: string | null;
};

const initialState: IUserProfileState = {
  profile: null,
  loading: false,
  error: null,
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<ILoginUser | null>) => {
      state.profile = action.payload;
    },
    setUserProfileLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUserProfileError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setUserProfile,
  setUserProfileLoading,
  setUserProfileError,
} = userProfileSlice.actions;

export default userProfileSlice.reducer;